var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'current-select': _vm.parent.value === _vm.value }, { 'is-disabled': _vm.disabled }, 'select-option'],on:{"click":function($event){$event.stopPropagation();return _vm.optionChange({ label: _vm.label, value: _vm.value })}}},[_c('label',{attrs:{"title":_vm.label}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }